let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
item.addEventListener("mouseover", () => {
item.setAttribute("open", true);
item.querySelector("ul").addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
item.addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
});

});



/* price update on variant change */
$(document).ready(function(){
    setTimeout(() => {
            updateVariantPrice();
    }, 1000); 

    $(".product__info-wrapper variant-radios :radio").on('change', function(e){
        setTimeout(() => {
            updateVariantPrice();
        }, 250); 
    });
});
function updateVariantPrice(){

    if($(".hidden-pro-variants").length){
        var varVID= $(".product__info-wrapper variant-radios input[type='radio']:checked").attr("data-vid");
        var varID = $(".product__info-wrapper product-form input[name='id']").val();

        if (!varVID) {
            varVID = varID;
        }
        var varPrice = parseInt($(".hidden-pro-variants select option[value='"+ varVID +"']").attr("data-price"));
        var varCPrice = parseInt($(".hidden-pro-variants select option[value='"+ varVID +"']").attr("data-cprice"));
        var varDiscount = parseInt($(".hidden-pro-variants select option[value='"+ varVID +"']").attr("data-disc"));
         console.log('uppdatedddddd',varPrice,varCPrice,varDiscount,varVID);
         $('[name="id"]').val(varVID);
        if(varPrice != undefined){
            $(".product__info-wrapper .price-item.price-item--sale").html(Shopify.formatMoney(varPrice, 'Rs. {{amount}}'));
             console.log('updateddddundefined',varPrice,varCPrice,varDiscount); 
            $(".op_price").html(Shopify.formatMoney(varPrice, 'Rs. {{amount}}'));
        }
        if(varCPrice > varPrice){  
            $(".product__info-wrapper .price-item.price-item--regular").html(Shopify.formatMoney(varCPrice, 'Rs. {{amount}}'));
            $(".product__info-wrapper .price-item.price-item--regular").parents(".price").addClass("price--on-sale");
            console.log('varCPrice',varPrice,varCPrice,varDiscount);
            $(".op_price").html(Shopify.formatMoney(varPrice, 'Rs. {{amount}}'));
            $(".cp_price").html(Shopify.formatMoney(varCPrice, 'Rs. {{amount}}'));
        }else{ 
            $(".product__info-wrapper .price-item.price-item--regular").html(Shopify.formatMoney(varPrice, 'Rs. {{amount}}'));
            $(".product__info-wrapper .price-item.price-item--regular").parents(".price").removeClass("price--on-sale");
        }
        if(varDiscount > 0){
            $(".product__info-wrapper .discount-percent_main").html("("+varDiscount +"% OFF)");
            $(".product__info-wrapper .discount-percent_main").show();
        }else{
            $(".product__info-wrapper .discount-percent_main").hide();
        }
    }
}   
/* price update on variant change */